export default "__VITE_ASSET__Bqbjj6Fh__"